/**
 * session-lost.ts
 * What the app does when the API says the session is gone (a 401 outside
 * /auth/*, see http.ts noticeStatus): forget the session — including the
 * claims kept for opening the app with no signal — and go to the login,
 * remembering the screen to come back to. Several requests failing at once
 * navigate only once. Pending dictations stay on the phone and go out after
 * the next login.
 */
import type { Router } from 'vue-router';
import { clearSession } from './session.js';
import { clearMe } from './useMe.js';

let redirecting = false;

export async function handleSessionLost(router: Router): Promise<void> {
  const current = router.currentRoute.value;
  if (redirecting || current.name === 'login') return;
  redirecting = true;
  clearSession();
  clearMe();
  try {
    await router.replace({ name: 'login', query: { redirect: current.fullPath, sesion: 'vencida' } });
  } finally {
    redirecting = false;
  }
}
